import "./styles.less";

import { Button, Col, Form, Input, Row, Typography } from "antd";
import React, { useEffect, useState } from "react";

import { FullScreen } from "../../FullScreen/web";
import { Rule } from "antd/lib/form";
import { postRequest } from "../../../Utils/Functions";
import { useFacebookPixel } from "shared-components/GlobalHooks/web/FacebookPixel.hook";
import { useUser } from "../../User/User.hook";
import { formatMoney } from "../../../Utils/Functions";
import { CloseButton } from "shared-components/Components/CustomIcons/CloseButton/web";
import dynamic from "next/dynamic"
const Modal = dynamic(() => import("shared-components/Components/Modal/web").then(mod => mod.Modal), { ssr: false });

const BBVASecondScreen = ({ extraData, loading, submitForm, sendText }) => {
	return (
		<div className="bbva-second-screen">
			<Row>
				<Col xs={24}>
					<Typography.Title level={3} className="title">
						Resumen de simulación:
					</Typography.Title>
				</Col>
			</Row>
			<Row>
				<Col xs={12} className="fee">
					<Typography.Title level={3}>Tu Cuota *:</Typography.Title>
				</Col>
				<Col xs={12}>
					<Typography.Title level={3} className="price">
						{extraData && `$ ${formatMoney(extraData.primer_cuota_con_gastos_uy)}`}
					</Typography.Title>
				</Col>
			</Row>
			<Row>
				<Col xs={12} offset={12} className="time-limit">
					<Typography.Text>
						{extraData &&
							extraData.plazo &&
							"Plazo a" + " " + extraData.plazo + " " + "años"}
					</Typography.Text>
				</Col>
			</Row>
			<Row>
				<Col xs={12}>
					<Typography.Text>
						{"Gastos Administrativos"}{" "}
						{extraData &&
							extraData.gastos_admin_uy &&
							`$ ${formatMoney(extraData.gastos_admin_uy)}`}
					</Typography.Text>
				</Col>
				<Col xs={12}>
					<Typography.Text>
						{"Prima seguro incendio"}{" "}
						{extraData &&
							extraData.prima_seguro_incendio_uy &&
							`$ ${formatMoney(extraData.prima_seguro_incendio_uy)}`}
					</Typography.Text>
				</Col>
			</Row>
			<Row>
				<Col xs={12}>
					<Typography.Text>
						{"Control garantía"}{" "}
						{extraData &&
							extraData.control_garantia_uy &&
							`$ ${formatMoney(extraData.control_garantia_uy)}`}
					</Typography.Text>
				</Col>
				<Col xs={12}>
					<Typography.Text>
						{"Capital total"}{" "}
						{extraData &&
							extraData.capital_total_uy &&
							`$ ${formatMoney(extraData.capital_total_uy)}`}
					</Typography.Text>
				</Col>
			</Row>
			<Row className="information-text">
				<Col xs={24}>
					<Typography.Paragraph>
						(*)
						{"La cuota incluye los gastos administrativos, el seguro de incendio y el control garantía"}
					</Typography.Paragraph>
				</Col>
			</Row>
			<Row>
				<Col xs={24}>
					<Button
						type="primary"
						className="btn-send-lead"
						loading={loading}
						onClick={submitForm}
						block>
						{sendText}
					</Button>
				</Col>
			</Row>
			<Row className="second-informational-text">
				<Col xs={24}>
					<Typography.Paragraph>
						La información contenida en la presente simulación es a título de ejemplo, quedando el otorgamiento del préstamo sujeto en cualquier caso a aprobación crediticia por parte del Banco y a los términos y condiciones que el mismo disponga para cada caso concreto.
					</Typography.Paragraph>
				</Col>
			</Row>
		</div>
	);
};

export interface ContactModalProps {
	visible: boolean;
	closeModal: () => void;
	title: string;
	topText?: string;
	bottomText?: string[];
	extraData: any;
	sendLeadURL: any;
	onSuccess: any;
	showCI?: boolean;
	showTel?: boolean;
	sendText?: string;
	handleContact?: any;
	reference?: string;
	source?: number;
	beforeSubmitForm?: () => any;
	hasSecondScreen?: boolean;
}

export const ContactModal = ({
	visible,
	closeModal,
	title,
	topText = null,
	bottomText = null,
	extraData,
	sendLeadURL,
	onSuccess,
	showCI = false,
	showTel = false,
	sendText = "Enviar Consulta",
	handleContact = null,
	reference = "",
	source = 0,
	beforeSubmitForm,
	hasSecondScreen = false,
}: ContactModalProps) => {
	const { user } = useUser();
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [formCompleted, setFormCompleted] = useState(false);
	const [secondScreen, setSecondScreen] = useState(false);
	const [formValues, setFormValues] = useState(null);
	const FP = useFacebookPixel();

	useEffect(() => {
		if (formCompleted) {
			FP.StandardEvent("CompleteRegistration");
		}
	}, [formCompleted]);

	useEffect(() => {
		if (visible) {
			form.setFieldsValue({
				nombre: user.data?.me?.name,
				apellido: user.data?.me?.lastName,
				email: user.data?.me?.email,
				telefono: user.data?.me?.phone,
				tel: user.data?.me?.phone,
				ci: user.data?.me?.ci,
			});
		}
	}, [user, visible]);

	const validateMessages = {
		required: "El ${label} es requerido!",
		types: {
			email: "El ${label} no es válido!",
			number: "El ${label} no es un numero válido!",
		},
	};

	const validateRules: { [x: string]: Rule[] } = {
		nombre: [{ required: true }],
		apellido: [{ required: true }],
		telefono: [
			{
				required: true,
				pattern: new RegExp("^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-s./0-9]*$"),
				message: "Teléfono no válido",
			},
		],
		email: [{ required: true, type: "email" }],
	};

	const submitForm = () => {
		form.validateFields()
			.then(async v => {
				const values = secondScreen ? formValues : v;

				reference ? (values.referencia = reference) : null;
				setLoading(true);
				if (sendLeadURL !== "") {
					let extra;

					if (beforeSubmitForm) {
						extra = await beforeSubmitForm();
					}

					const extraDataToSend = extra ? extra : extraData;

					const tel = values.telefono ? values.telefono : "";

					const userId =
						user && user.data && user.data.me && user.data.me.id ? user.data.me.id : "";

					let data = await postRequest(sendLeadURL, {
						...values,
						...extraDataToSend,
						tel: tel,
						IDuser: userId,
						source: source,
					});
					setFormCompleted(true);
					setSecondScreen(false);
					onSuccess();
				} else {
					let data = await handleContact({ ...values, ...extraData });
					if (data) {
						setFormCompleted(true);
						setSecondScreen(false);
						onSuccess();
					}
				}
				setLoading(false);
			})
			.catch(e => { });
	};

	const continueToSecondScreen = () => {
		form.validateFields()
			.then(values => {
				setSecondScreen(true);
				setFormValues(values);
			})
			.catch(e => {
				setSecondScreen(false);
			});
	};

	return (
		<Modal
			show={visible}
			onClose={() => {
				setSecondScreen(false);
				closeModal();
			}}
			title={title}>
			<div className="form-modal">
				<FullScreen offset={55} className="modal-form-content financing-form">
					<Form
						form={form}
						name="financing-form"
						initialValues={{
							nombre: user.data?.me?.firstName,
							apellido: user.data?.me?.lastName,
							email: user.data?.me?.email,
							telefono: user.data?.me?.phone,
							ci: user.data?.me?.ci,
						}}
						scrollToFirstError
						labelCol={{ span: 0 }}
						validateMessages={validateMessages}>
						{hasSecondScreen && secondScreen ? (
							<BBVASecondScreen
								extraData={extraData}
								loading={loading}
								submitForm={submitForm}
								sendText={sendText}
							/>
						) : (
							<Row gutter={12}>
								{topText ? (
									<Col xs={24}>
										<Typography.Paragraph>{topText}</Typography.Paragraph>
									</Col>
								) : null}
								<Col xs={24} md={12}>
									<Form.Item
										name="nombre"
										label="Nombre"
										hasFeedback
										rules={validateRules.nombre}>
										<Input className="secondary" placeholder={"Nombre" + " *"} />
									</Form.Item>
								</Col>
								<Col xs={24} md={12}>
									<Form.Item
										name="apellido"
										label="Apellido"
										hasFeedback
										rules={validateRules.apellido}>
										<Input
											className="secondary"
											placeholder={"Apellido" + " *"}
										/>
									</Form.Item>
								</Col>
								<Col xs={24}>
									<Form.Item
										name="email"
										label="Email"
										hasFeedback
										rules={validateRules.email}>
										<Input
											className="secondary"
											placeholder={"Correo Electrónico" + " *"}
										/>
									</Form.Item>
								</Col>
								<Col xs={24}>
									<Form.Item
										name={showTel ? "tel" : "telefono"}
										label="Teléfono"
										hasFeedback
										rules={validateRules.telefono}>
										<Input
											className="secondary"
											placeholder={"Teléfono" + " *"}
										/>
									</Form.Item>
								</Col>
								{showCI ? (
									<Col xs={24}>
										<Form.Item name="ci" label="CI" hasFeedback>
											<Input className="secondary" placeholder="C.I." />
										</Form.Item>
									</Col>
								) : null}
								<Col xs={24}>
									<Form.Item>
										{hasSecondScreen ? (
											<Button type="primary" onClick={continueToSecondScreen}>
												Continuar
											</Button>
										) : (
											<Button
												type="primary"
												className="btn-send-lead"
												loading={loading}
												onClick={submitForm}>
												{sendText}
											</Button>
										)}
									</Form.Item>
								</Col>
								{bottomText ? (
									<Col xs={24}>
										{bottomText.map((text, i) => (
											<Typography.Paragraph
												key={"contat_p_" + i}
												type="secondary">
												{text}
											</Typography.Paragraph>
										))}
									</Col>
								) : null}
							</Row>
						)}
					</Form>
				</FullScreen></div>

		</Modal>
	);
};
